import { Box } from '@mui/material';

import ComponentGuard from '../../../../components/ComponentGuard';
import { ALL_ROLES } from '../../../../config/roles';
import BulkUploader from '../components/BulkUploader';
import { PERMISSIONS } from '../../../../config/permissions';

const AddBulk = () => {
  return (
    <Box>
      <ComponentGuard
        auth={{
          atLeast: ALL_ROLES.ASSETICOM_ADMIN,
          allowedUids: [...PERMISSIONS.BULK_UPLOADING],
        }}
      >
        <BulkUploader />
      </ComponentGuard>
    </Box>
  );
};

export default AddBulk;
